export default __webpack_public_path__ + "static/media/Punto_04_Quartiere_Venezia_FRA_Def.8faa2c28.aac";